import type { SVGProps } from 'react';
const SvgForwardToInbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#forward_to_inbox_svg__a)">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2Zm-8 7L4 6h16l-8 5Zm7 4 4 4-4 4v-3h-4v-2h4v-3Z"
      />
    </g>
    <defs>
      <clipPath id="forward_to_inbox_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgForwardToInbox;
